/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-02-15 14:56:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'
const routerComponents = {
  indexIndicator: () => import('./indicator/index.vue'),
  indexPlan: () => import('./plan/index.vue'),
  indexPlanReport: () => import('./planReport/index.vue'),
  indexSpecialIndicator: () => import('./specialIndicator/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '质量管理',
        icon: 'chart'
      },
      children: [
        {
          path: 'ZKZB/ZKZBList',
          component: dynamicWrapper(
            ['qc-plan/indicator'],
            routerComponents.indexIndicator
          ),
          meta: { title: '质控指标', noCache: true }
        },
        {
          path: 'ZKJH/ZKJHList',
          component: dynamicWrapper(
            ['qc-plan/plan'],
            routerComponents.indexPlan
          ),
          meta: { title: '质控计划', noCache: true }
        },
        {
          path: 'ZKJH/ZKJHReport',
          component: dynamicWrapper(
            ['qc-plan/planReport'],
            routerComponents.indexPlanReport
          ),
          meta: { title: '质控计划汇总', noCache: true }
        },
        {
          path: 'ZKZB/TDZBReport',
          component: dynamicWrapper(
            ['qc-plan/specialIndicator'],
            routerComponents.indexSpecialIndicator
          ),
          meta: { title: '专项指标统计', noCache: true }
        }
      ]
    }
  ]
}
